import * as Dialog from '@radix-ui/react-dialog';
import { type ReactNode } from 'react';
// 공지사항 이미지 import (src/assets/images에서 가져옴)
import noticeImage from '@/assets/images/20251124_Notice_BA.png';

type NoticeDialogProps = {
  open: boolean;
  imageSrc?: string;
  alt?: string;
  children?: ReactNode;
};

export default function NoticeDialog({ open, imageSrc = noticeImage, alt = '공지사항', children }: NoticeDialogProps) {
  return (
    <Dialog.Root open={open} onOpenChange={() => {}}>
      <Dialog.Portal>
        {/* 백드롭 */}
        <Dialog.Overlay className="fixed inset-0 z-[60] bg-black/80" />

        {/* 모달 본체 */}
        <Dialog.Content
          className="fixed left-1/2 top-1/2 z-[70] max-h-[90vh] w-auto max-w-[90%] -translate-x-1/2 -translate-y-1/2 overflow-hidden rounded-lg"
          onEscapeKeyDown={(e) => {
            // ESC 키로 닫히지 않도록 방지
            e.preventDefault();
          }}
          onPointerDownOutside={(e) => {
            // 외부 클릭으로 닫히지 않도록 방지
            e.preventDefault();
          }}
          onInteractOutside={(e) => {
            // 외부 상호작용으로 닫히지 않도록 방지
            e.preventDefault();
          }}
        >
          {/* 접근성을 위한 숨겨진 제목 */}
          <Dialog.Title className="sr-only">{alt}</Dialog.Title>
          {children ? (
            children
          ) : (
            <img
              src={imageSrc}
              alt={alt}
              className="block h-full max-h-[90vh] w-full max-w-[90vw] cursor-default object-contain"
              onClick={(e) => {
                // 클릭해도 닫히지 않도록 이벤트 전파 방지
                e.stopPropagation();
              }}
              onError={(e) => {
                // 이미지 로드 실패 시 기본 이미지 또는 placeholder 표시
                console.warn('공지사항 이미지를 불러올 수 없습니다.');
              }}
            />
          )}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
